import { AlertCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'

/**
 * Shared "this one card failed" treatment — icon + reassurance that the rest
 * of the dashboard is unaffected (each card queries independently) + a retry
 * action, matching the design's generic card-error state (screen 4c).
 */
export default function CardErrorState({ onRetry }: { onRetry?: () => void }) {
  return (
    <div className="flex h-24 flex-col items-center justify-center gap-1.5 text-center">
      <AlertCircle className="size-5 text-txt-secondary" />
      <div className="text-sm font-medium text-txt-primary">Couldn&apos;t load this card</div>
      <div className="text-xs text-txt-secondary">The rest of the dashboard is up to date.</div>
      {onRetry && (
        <Button variant="outline" size="sm" onClick={onRetry} className="mt-1">
          Retry
        </Button>
      )}
    </div>
  )
}
